<script>
export default {
  page: {
    title: '編輯預付方案',
    meta: [{ name: 'description', content: 'Edit Prepaid' }],
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeTab: '1',
      tabList: Object.freeze([
        {
          title: '基本資訊',
          component: () => import('./components/Step1Basic'),
        },
        {
          title: '適用項目',
          component: () => import('./components/Step2Prices'),
        },
      ]),
      tryingToSave: false,
    }
  },
  methods: {
    async onClickSave() {
      this.tryingToSave = true
      try {
        await this.$store.dispatch(
          'prepaid/store',
          this.$refs[`step${this.activeTab}`][0].submitData
        )
        await this.$alert('儲存成功', '太棒了！', {
          confirmButtonText: '確認',
          type: 'success',
          center: true,
        })
        this.tryingToSave = false
      } catch (error) {
        this.tryingToSave = false
      }
    },
  },
}
</script>
<template>
  <div :class="$style.page">
    <BasePageHeader title="編輯預付方案" />
    <el-tabs v-model="activeTab" type="border-card">
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :key="index"
        :label="tab.title"
        :name="`${index + 1}`"
      >
        <component :is="tab.component" :ref="`step${index + 1}`" :default-value="defaultValue"></component>

        <div :class="$style.footer">
          <el-button class="is-round" :loading="tryingToSave" @click="$router.push({ name: 'prepaid' })">取消</el-button>
          <el-button class="is-round" type="primary" :loading="tryingToSave" @click="onClickSave">儲存變更</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
</style>
